import * as zod from 'zod';

import type { RoutineContext } from '@sb/routine-runner/RoutineContext';
import type { RoutineFrame } from '@sb/routine-runner/RoutineFrame';

export const PythonExpression = zod.object({
  kind: zod.literal('Python'),
  expression: zod.string(),
  errorMessage: zod.string().optional().nullable(),
});

export type PythonExpression = zod.infer<typeof PythonExpression>;

export type PyRunner = {
  evaluate(args: {
    code: string;
    contextKind: string;
    routineContext: RoutineContext;
    /** The frame the expression evaluates against (its call scope). */
    frame: RoutineFrame;
  }): Promise<unknown>;
};
